export const BASE_URL = process.env.API_ENV === 'production' || !process.env.API_ENV
  ? 'https://api.flex-appeal.nl'
  : `https://api.flex-appeal-${process.env.API_ENV}.dev`;
